import React from 'react';
import { motion } from 'framer-motion';
const photos = [{
  url: 'https://images.unsplash.com/photo-1589939705384-5185137a7f0f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Drywall Installation',
  status: 'Phase 3: Interiors'
}, {
  url: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Residential Addition',
  status: 'Phase 1: Foundation'
}, {
  url: 'https://images.unsplash.com/photo-1541888086925-0c13d4f47c62?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Commercial Remodel',
  status: 'Phase 4: Finishes'
}, {
  url: 'https://images.unsplash.com/photo-1621905251189-08b45d6a269e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Electrical Installation',
  status: 'Phase 2: Systems'
}, {
  url: 'https://images.unsplash.com/photo-1531834685032-c34bf0d84c77?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Roof Structure',
  status: 'Phase 2: Construction'
}];
export function InProgress() {
  return <section id="projects" className="py-24 bg-light-alt" data-id="element-188">
      <div className="container mx-auto px-6 md:px-12" data-id="element-189">
        <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-6" data-id="element-190">
          <div className="max-w-2xl" data-id="element-191">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} data-id="element-192">
              <h2 className="text-accent font-medium tracking-widest uppercase text-sm mb-3" data-id="element-193">
                Full Transparency
              </h2>
              <h3 className="text-4xl md:text-5xl font-serif font-bold text-primary mb-4" data-id="element-194">
                Projects In Progress
              </h3>
              <p className="text-gray-600 text-lg" data-id="element-195">
                We take pride in showing not just the final result, but also the
                quality and order of our construction process.
              </p>
            </motion.div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-196">
          {photos.map((photo, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group relative overflow-hidden rounded-sm aspect-[4/3] bg-gray-200" data-id="element-197">
              <img src={photo.url} alt={photo.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-198" />
              <div className="absolute inset-0 bg-gradient-to-t from-primary/90 via-primary/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-6" data-id="element-199">
                <span className="text-accent text-sm font-medium mb-1" data-id="element-200">
                  {photo.status}
                </span>
                <h4 className="text-white text-xl font-serif font-bold" data-id="element-201">
                  {photo.title}
                </h4>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}